export const getMemberTypeId = ({ memberTypeName, memberTypePlans }) => {
	return memberTypePlans.find(plan => plan.member_type === memberTypeName)?.id;
};
